<template lang="pug">
  div.page-content
    h1.titulo Manual do usuário
    p {{ DESCRICAO }}
    el-row.cards-row(v-if="isEstadoMA()")
      el-col
        div(class="manual-container align-end")
          el-card.card(v-if="MANUAL_OFF" :body-style="{width: '100%'}")
            .card-content
              img.icon-card(src="@/assets/images/manualOffline.png" height="100px" width="80px")
              p.text-center Baixar Manual do SiCARF Off-line
              el-button.botao(
                type="success",
                @click="baixarManual('Off')",
                :loading="loading",
                icon="fas fa-cloud-download-alt"
              )
                span
                  b.text-botao Baixar

          iframe.default-iframe(v-if="VIDEOS_TUTORIAIS" showinfo="0" width="100%" height="350" rel="0" :src="VIDEOS_TUTORIAIS.MANUAL_USUARIO_OFF" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen modestbranding="1")
      el-col
        div(class="manual-container align-end")
          el-card.card(v-if="MANUAL_OFF" :body-style="{width: '100%'}")
            .card-content
              img.icon-card(src="@/assets/images/manualOffline.png" height="100px" width="80px")
              p.text-center Baixar Manual de Cadastro de Processos Onerosos e Não Onerosos Rurais
              el-button.botao(
                type="success",
                @click="baixarManual('Off_oneroso_nao_oneroso')",
                :loading="loading",
                icon="fas fa-cloud-download-alt"
              )
                span
                  b.text-botao Baixar

          iframe.default-iframe(v-if="VIDEOS_TUTORIAIS" showinfo="0" width="100%" height="350" rel="0" :src="VIDEOS_TUTORIAIS.MANUAL_USUARIO_OFF" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen modestbranding="1")
      el-col
        div(class="manual-container align-end")
          el-card.card(v-if="MANUAL_OFF" :body-style="{width: '100%'}")
            .card-content
              img.icon-card(src="@/assets/images/manualOffline.png" height="100px" width="80px")
              p.text-center Baixar Manual de Cadastro de Processos de Territórios Tradicionais - TT
              el-button.botao(
                type="success",
                @click="baixarManual('Off_tq')",
                :loading="loading",
                icon="fas fa-cloud-download-alt"
                :disabled="true"
              )
                span
                  b.text-botao Baixar

          iframe.default-iframe(v-if="VIDEOS_TUTORIAIS" showinfo="0" width="100%" height="350" rel="0" :src="VIDEOS_TUTORIAIS.MANUAL_USUARIO_OFF" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen modestbranding="1")

      div(class="manual-container align-start")
        el-card.card(v-if="MANUAL_ON" :body-style="{width: '100%'}")
          .card-content
            img.icon-card(src="@/assets/images/manualOnline.png" height="100px"  width="80px")
            p.text-center Baixar Manual do SiCARF On-line
            el-button.botao(
              type="success",
              @click="baixarManual('On')",
              :loading="loading",
              icon="fas fa-cloud-download-alt"
            )
              span
                b.text-botao Baixar

        iframe.default-iframe(v-if="VIDEOS_TUTORIAIS" showinfo="0" width="100%" height="350" rel="0" :src="VIDEOS_TUTORIAIS.MANUAL_USUARIO" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen modestbranding="1")

    el-row.cards-row(v-else)
      div(class="manual-container align-end")
        el-card.card(v-if="MANUAL_OFF" :body-style="{width: '100%'}")
          .card-content
            img.icon-card(src="@/assets/images/manualOffline.png" height="100px" width="80px")
            p.text-center Baixar Manual do SiCARF Off-line
            el-button.botao(
              type="success",
              @click="baixarManual('Off')",
              :loading="loading",
              icon="fas fa-cloud-download-alt"
              :disabled="true"
            )
              span
                b.text-botao Baixar

        iframe.default-iframe(v-if="VIDEOS_TUTORIAIS" showinfo="0" width="100%" height="350" rel="0" :src="VIDEOS_TUTORIAIS.MANUAL_USUARIO_OFF" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen modestbranding="1")

      div(class="manual-container align-start")
        el-card.card(v-if="MANUAL_ON" :body-style="{width: '100%'}")
          .card-content
            img.icon-card(src="@/assets/images/manualOnline.png" height="100px"  width="80px")
            p.text-center Baixar Manual do SiCARF On-line
            el-button.botao(
              type="success",
              @click="baixarManual('On')",
              :loading="loading",
              icon="fas fa-cloud-download-alt"
              :disabled="true"
            )
              span
                b.text-botao Baixar

        iframe.default-iframe(v-if="VIDEOS_TUTORIAIS" showinfo="0" width="100%" height="350" rel="0" :src="VIDEOS_TUTORIAIS.MANUAL_USUARIO" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen modestbranding="1")

</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  data () {
    return {
      loading: false
    }
  },

  computed: {
    ...mapState({
      DESCRICAO: state => state.userInterface.dadosEstado.PUBLICO.MANUAL_USUARIO.DESCRICAO,
      MANUAL_OFF: state => state.userInterface.dadosEstado.PUBLICO.MANUAL_USUARIO.MANUAL_OFF,
      MANUAL_ON: state => state.userInterface.dadosEstado.PUBLICO.MANUAL_USUARIO.MANUAL_ON,
      VIDEOS_TUTORIAIS: state => state.userInterface.dadosEstado.PUBLICO.VIDEOS_TUTORIAIS
    })
  },

  methods: {
    ...mapActions({
      downloadManual: 'downloadPortal/downloadManual'
    }),

    async baixarManual (tipoManual) {
      this.loading = true
      this.downloadManual('MANUAL_' + tipoManual.toUpperCase())
      this.loading = false
    },
    isEstadoMA () {
      return process.env.ESTADO === 'ma'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/element-variables.scss';
.page-content {
  display: flex;
  flex-direction: column;
  min-height: 75vh;
}

.titulo {
  color: $--color-primary;
}

.cards-row {
  display: flex;
}

.card {
  width: 220px;
  min-height: 240px;
  border-color: $--color-primary;
  display: flex;
  background-color: rgba(0, 158, 97, 0.04);
  box-shadow: 0 10px 70px 0 rgba(0, 0, 0, 0.1) !important;
}

.card:hover {
  .text-center {
    opacity: 0;
  }
  .botao {
    opacity: 1;
    display: block;
  }
}

.card-content {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.text-botao {
  margin-left: 10px;
}

.text-center {
  text-align: center;
  color: $--color-primary;
  z-index: 0;
  transition: opacity 0.2s ease-in;
}

.botao {
  opacity: 0;
  transition: opacity 0.2s ease-in;
  top: 185px;
  position: absolute;
}

p {
  line-height: 1.5;
  font-size: 1.2em;
}

.manual-container {
  display: flex;
  flex-direction: column;
  padding: 20px;
  width: 100%;
}

.align-end {
  align-items: center;
}

.align-start {
  align-items: center;
}

iframe {
  margin-top: 20px;
  border-radius: 10px;
}

.icon-card {
  align-self: center;
}

@media (max-width: 590px) {
  .card {
    width: 290px
  }
  .cards-row {
    flex-direction: column;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/portal/publico/ManualUsuario.vue